import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type WhatsappMmLiteProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const WhatsappMmLite = ({ size = 24, width, height, alt = '', style, ...props }: WhatsappMmLiteProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      xmlns: 'http://www.w3.org/2000/svg',
      fill: 'none',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'matrix(0.73812087 0 0 0.73812087 -0.75565124 0.19006612)',
        },
        [
          h(
            'path',
            {
              d: 'M30.7524 4.65005L29.3446 3.32505C29.2915 3.27505 29.2251 3.25317 29.1554 3.25317C29.0856 3.25317 29.0192 3.27817 28.9661 3.32505L26.4394 5.70317C25.3204 4.98755 24.0188 4.6313 22.7173 4.6313C21.0173 4.6313 19.3173 5.24067 18.019 6.46255L14.6356 9.64692C14.5327 9.7438 14.5327 9.90317 14.6356 10L23.6569 18.4907C23.7101 18.5407 23.7765 18.5625 23.8462 18.5625C23.9126 18.5625 23.9823 18.5375 24.0354 18.4907L27.4188 15.3063C29.7065 13.15 29.9755 9.81567 28.2257 7.38442L30.7524 5.0063C30.8554 4.9063 30.8554 4.74692 30.7524 4.65005ZM19.5032 17.0844C19.4003 16.9875 19.231 16.9875 19.128 17.0844L16.9167 19.1657L13.9185 16.3438L16.1331 14.2594C16.236 14.1625 16.236 14.0032 16.1331 13.9063L14.9245 12.7688C14.8216 12.6719 14.6522 12.6719 14.5493 12.7688L12.3347 14.8532L10.9069 13.5094C10.8538 13.4594 10.7874 13.4375 10.7177 13.4375C10.6513 13.4375 10.5815 13.4625 10.5284 13.5094L7.14834 16.6938C4.86064 18.8469 4.5917 22.1844 6.3415 24.6157L3.81475 26.9938C3.71182 27.0907 3.71182 27.25 3.81475 27.3469L5.22256 28.6719C5.27568 28.7219 5.34209 28.7438 5.41182 28.7438C5.48154 28.7438 5.54795 28.7188 5.60107 28.6719L8.12783 26.2938C9.24678 27.0094 10.5483 27.3657 11.8499 27.3657C13.5499 27.3657 15.2499 26.7563 16.5481 25.5344L19.9315 22.35C20.0345 22.2532 20.0345 22.0938 19.9315 21.9969L18.5038 20.6532L20.7185 18.5688C20.8214 18.4719 20.8214 18.3125 20.7185 18.2157L19.5032 17.0844Z',
              fill: '#602DED',
            },
          ),
        ],
      ),
    ],
  );

export default WhatsappMmLite;
